<template>
  <div
    class="row"
    :class="styleSelectable()"
    >

    <card-number :index="index" />

    <div
      class="card-suit"
      v-for="(img, i) in suitImages"
      :key="i">

      <suit
       :suit="suit"
       :suit-image="img"
       />
    </div>

    <button-check :index="index" />
  </div>
</template>

<script>
import CardNumber from '@/components/Answer/Sheet/CardNumber'
import ButtonCheck from '@/components/Answer/Sheet/ButtonCheck'
import Suit from '@/components/Answer/Sheet/Suit'

export default {
  props: {
    suit: {
      type: Object
    },

    index: {
      type: Number
    }
  },

  components: {
    CardNumber,
    ButtonCheck,
    Suit
  },

  data () {
    return {
      suitImages: [
        { name: 'spades', src: '/img/cards/s_0.svg' },
        { name: 'hearts', src: '/img/cards/h_0.svg' },
        { name: 'diamonds', src: '/img/cards/d_0.svg' },
        { name: 'clubs', src: '/img/cards/c_0.svg' }
      ]
    }
  },

  methods: {
    styleSelectable: function () {
      if (this.$store.getters['answer/isMatch'](this.index)) {
        return { 'row-selectable': true }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_style.scss';
.row {
  display: flex;
  &:first-child {
    border-top: 1px solid $wet-asphalt;
  }

  &-selectable {
    background: rgba(52, 152, 219, 0.3);
  }
}

.card {
  &-suit {
    padding: 5px;
    @include cell;
  }
}
</style>
